export const COMPILATION_SUCCESS = "COMPILATION_SUCCESS";
export const COMPILATION_ERROR = "COMPILATION_ERROR";
export const RUNTIME_ERROR = "RUNTIME_ERROR";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const GET_PROBLEMS = "GET_PROBLEMS";
export const PROBLEM_ERROR = "PROBLEM_ERROR";
export const GET_PROBLEM = "GET_PROBLEM";
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILES = "GET_PROFILES";
export const CLEAR_PROFILE = "CLEAR_PROFILE";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const ACCOUNT_DELETED = "ACCOUNT_DELETED";
export const GET_SOLVED = "GET_SOLVED";
export const CLEAR_RESULT = "CLEAR_RESULT";
export const CLEAR_PROBLEM = "CLEAR_PROBLEM";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
